import { createSelector } from 'reselect'
import { dataConstants } from 'services/redux/data/constants'
import ObjectEmployee from 'utils/objects/employee'
import _ from 'lodash'

const selectFavourites = createSelector(
	[
		(state) => {
			return state.data[dataConstants.FAVOURITES];
		}
	],
	( employees ) => {
		return employeeSort( ObjectEmployee.filterInvisible( employees ) );
	}
)

// Sort by value and put back by guid
const employeeSort = ( employees ) => {
	let list = {}
	
	_.forEach( _.sortBy( employees, [ (o) => {
		return o.name;
	} ] ), o => {
		list[ o.guid ] = o;
	});
	
	return { ...list }
}


export default selectFavourites;